import { autoGeneratedReducer } from '@hh.ru/redux-create-reducer';

export interface CodeForwardResult {
    success?: boolean;
    errorMessage?: string;
}

export default autoGeneratedReducer<CodeForwardResult>({});
